import React from 'react';
import { Grid, Paper, Box, Button, Typography, CircularProgress, Tabs, Tab ,IconButton  } from '@mui/material';
import ChatWindow from '../ChatWindow';
import FlowContainer from '../FlowContainer';
import RefreshIcon from '@mui/icons-material/Refresh';
import ClarityAnalytics from '../clarity';

const DataModelsTab = ({
  dataModelMessages,
  handleDataModelMessage,
  handleEditMessage,
  handleDeleteMessage,
  isLoading,
  dataModelSummary,
  selectedProject,
  dataModelNodes,
  setDataModelNodes,
  dataModelEdges,
  setDataModelEdges,
  handleNextStepFromDataModels,
  gridContainerStyles,
  leftColumnStyles,
  rightColumnStyles,
  customNodes,
  deploymentStatus,
  getDeployButtonText,
  dataSideTab,
  handleRightTabChange,
  generatedSQL,
  handleRefreshDataModels
}) => {

  const preAdditionalSql = `CREATE TABLE messageQueue (id INT AUTO_INCREMENT PRIMARY KEY, queueName VARCHAR(255) Unique,PrimaryKey VARCHAR(255));
  CREATE TABLE Roles (
  role_id INT NOT NULL AUTO_INCREMENT PRIMARY KEY,
  role_name VARCHAR(50) NOT NULL,
  createdBy VARCHAR(255),
  modifiedBy VARCHAR(255),
  createdAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP,
  modifiedAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1
  );
  INSERT INTO Roles (role_name, isActive)
  VALUES ('Administrator', 1);
  
  CREATE TABLE Users (
  user_id INT NOT NULL AUTO_INCREMENT PRIMARY KEY,
  username VARCHAR(50) NOT NULL,
  password_hash VARCHAR(255) NOT NULL,
  role_id INT NOT NULL,
  createdBy VARCHAR(255),
  modifiedBy VARCHAR(255),
  createdAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP,
  modifiedAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  FOREIGN KEY (role_id) REFERENCES Roles(role_id)
  
  );
  INSERT INTO Users (username, password_hash, role_id,isActive)
  VALUES ('admin',  'admin', 1, 1);
  
  CREATE TABLE Entities (
  entity_id INT NOT NULL AUTO_INCREMENT PRIMARY KEY,
  entity_name VARCHAR(100) NOT NULL,
  createdBy VARCHAR(255),
  modifiedBy VARCHAR(255),
  createdAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP,
  modifiedAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1
  );
  
  CREATE TABLE PermissionMatrix (
  permission_id INT NOT NULL AUTO_INCREMENT PRIMARY KEY,
  role_id INT NOT NULL,
  entity_id INT NOT NULL,
  can_read TINYINT(1),
  can_write TINYINT(1),
  can_update TINYINT(1),
  can_delete TINYINT(1),
  user_id INT, -- Attribute for user identity
  owner_name VARCHAR(255), -- Attribute for owner of the resource
  createdBy VARCHAR(255),
  modifiedBy VARCHAR(255),
  createdAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP,
  modifiedAt TIMESTAMP DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  FOREIGN KEY (role_id) REFERENCES Roles(role_id),
  FOREIGN KEY (entity_id) REFERENCES Entities(entity_id)
  
  );
  INSERT INTO PermissionMatrix (role_id, entity_id, can_read, can_write, can_update, can_delete, user_id,owner_name)
  SELECT r.role_id, e.entity_id, 1, 1, 1, 1, u.user_id,u.username
  FROM Roles r
  CROSS JOIN Entities e
  JOIN Users u ON u.role_id = r.role_id
  WHERE r.role_name = 'Administrator';
  
  CREATE TABLE IF NOT EXISTS messageQueue (id INT AUTO_INCREMENT PRIMARY KEY, queueName VARCHAR(255) Unique,PrimaryKey VARCHAR(255));
  
  CREATE TABLE IF NOT EXISTS dnd_ui_versions (
  dnd_ui_version_id int NOT NULL AUTO_INCREMENT,
  layout longtext NOT NULL,
  components longtext NOT NULL,
  ui_pages longtext NOT NULL,
  dnd_ui_type varchar(45) NOT NULL,
  createdBy varchar(45) NOT NULL,
  modifiedBy varchar(45) NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL,
  PRIMARY KEY(dnd_ui_version_id)
  );
  CREATE TABLE IF NOT EXISTS s3bucket (
  bucket_id int NOT NULL AUTO_INCREMENT,
  bucket_name varchar(255) NOT NULL,
  bucket_url varchar(500) NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY(bucket_id)
  );
  INSERT INTO s3bucket (bucket_name, bucket_url,modifiedBy, createdBy,isActive) VALUES ('nocodes3dev','DO0089PZREULYLFACQZJ', 'admin', 'admin',1);
  CREATE TABLE IF NOT EXISTS s3bucket_folders (
  folder_id int NOT NULL AUTO_INCREMENT,
  folder_name varchar(45) NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (folder_id)
  );
  
  CREATE TABLE IF NOT EXISTS project_dnd_ui_versions (
  project_dnd_ui_version_id int NOT NULL AUTO_INCREMENT,
  project_id int NOT NULL,
  dnd_ui_version_id int NOT NULL,
  createdBy varchar(255) NOT NULL,
  modifiedBy varchar(255) NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL,
  PRIMARY KEY (project_dnd_ui_version_id),
  KEY fk_project_dnd_ui_versions_table (dnd_ui_version_id),
  CONSTRAINT fk_project_dnd_ui_versions_table FOREIGN KEY (dnd_ui_version_id) REFERENCES dnd_ui_versions (dnd_ui_version_id) ON DELETE RESTRICT ON UPDATE RESTRICT
  ) ENGINE=InnoDB AUTO_INCREMENT=11 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;
  
  CREATE TABLE IF NOT EXISTS workflow (
  id int NOT NULL AUTO_INCREMENT,
  steps longtext CHARACTER SET utf8mb4 COLLATE utf8mb4_bin NOT NULL,
  triggerpoint longtext CHARACTER SET utf8mb4 COLLATE utf8mb4_bin NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (id)
  ) ENGINE=InnoDB AUTO_INCREMENT=2 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflows (
  workflow_id int NOT NULL AUTO_INCREMENT,
  workflow_name varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  workflow_description varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  steps longtext CHARACTER SET utf8mb4 COLLATE utf8mb4_bin NOT NULL,
  triggerpoint longtext CHARACTER SET utf8mb4 COLLATE utf8mb4_bin NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_id)
  ) ENGINE=InnoDB AUTO_INCREMENT=5 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflow_builds (
  workflow_build_id int NOT NULL AUTO_INCREMENT,
  workflow_id int NOT NULL,
  workflow_build_status varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  workflow_build_start_time datetime NOT NULL,
  workflow_build_end_time datetime NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_build_id),
  KEY workflow_id (workflow_id),
  CONSTRAINT workflow_builds_ibfk_1 FOREIGN KEY (workflow_id) REFERENCES workflows (workflow_id)
  ) ENGINE=InnoDB AUTO_INCREMENT=7 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflows_projects (
  workflow_id int NOT NULL,
  project_id int NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_id,project_id),
  CONSTRAINT workflows_projects_ibfk_1 FOREIGN KEY (workflow_id) REFERENCES workflows (workflow_id)
  ) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  CREATE TABLE IF NOT EXISTS workflow_runs (
  workflow_run_id int NOT NULL AUTO_INCREMENT,
  workflow_build_id int NOT NULL,
  workflow_run_status varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  workflow_run_start_time datetime NOT NULL,
  workflow_run_end_time datetime NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_run_id),
  KEY workflow_build_id (workflow_build_id),
  CONSTRAINT workflow_runs_ibfk_1 FOREIGN KEY (workflow_build_id) REFERENCES workflow_builds (workflow_build_id)
  ) ENGINE=InnoDB AUTO_INCREMENT=7 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflow_deployments (
  workflow_deployment_id int NOT NULL AUTO_INCREMENT,
  workflow_run_id int NOT NULL,
  workflow_deployment_status varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  workflow_deployment_start_time datetime NOT NULL,
  workflow_deployment_end_time datetime NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_deployment_id),
  KEY workflow_run_id (workflow_run_id),
  CONSTRAINT workflow_deployments_ibfk_1 FOREIGN KEY (workflow_run_id) REFERENCES workflow_runs (workflow_run_id)
  ) ENGINE=InnoDB AUTO_INCREMENT=7 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflow_triggers (
  workflow_trigger_id int NOT NULL AUTO_INCREMENT,
  workflow_id int NOT NULL,
  trigger_name varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  trigger_type varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_trigger_id),
  KEY workflow_id (workflow_id),
  CONSTRAINT workflow_triggers_ibfk_1 FOREIGN KEY (workflow_id) REFERENCES workflows (workflow_id)
  ) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;
  
  CREATE TABLE IF NOT EXISTS workflow_trigger_conditions (
  workflow_trigger_id int NOT NULL,
  condition_type varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  condition_value varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  createdBy varchar(255) CHARACTER SET utf8mb4 COLLATE utf8mb4_general_ci NOT NULL,
  modifiedAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  createdAt datetime NOT NULL DEFAULT CURRENT_TIMESTAMP,
  isActive tinyint(1) NOT NULL DEFAULT 1,
  PRIMARY KEY (workflow_trigger_id),
  CONSTRAINT workflow_trigger_conditions_ibfk_1 FOREIGN KEY (workflow_trigger_id) REFERENCES workflow_triggers (workflow_trigger_id)
  ) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_general_ci;`;

  const postAdditionalSql =`
INSERT INTO Entities (entity_name, createdBy, modifiedBy, isActive)
SELECT TABLE_NAME, 'admin', 'admin', 1
FROM information_schema.tables
WHERE table_schema = DATABASE();

INSERT INTO PermissionMatrix (role_id, entity_id, can_read, can_write, can_update, can_delete, user_id, owner_name, createdBy, modifiedBy, isActive)
SELECT 1, e.entity_id, 1, 1, 1, 1, u.user_id, u.username, 'admin', 'admin', 1
FROM Entities e
JOIN Users u ON u.role_id = 1;` 
  return (
    <>
      <><ClarityAnalytics /></>
    <Grid container {...gridContainerStyles}>
      <Grid item {...leftColumnStyles}>
        <Paper elevation={0} className="bg-transparent">
          <ChatWindow
            messages={dataModelMessages}
            onSendMessage={handleDataModelMessage}
            placeholder="Enter data model..."
            title="Data Models Chat"
            onEditMessage={(index) => handleEditMessage("dataModel", index)}
            onDeleteMessage={(index) => handleDeleteMessage("dataModel", index)}
            isLoading={isLoading}
            summaries={dataModelSummary}
            type="dataModel"
            selectedProject={selectedProject}
          />
            {dataModelNodes.length > 0  && generatedSQL && (
        <Box className="mt-auto p-4 flex items-center space-x-4">
          <Button
            variant="contained"
            onClick={handleNextStepFromDataModels}
            disabled={getDeployButtonText(deploymentStatus) === 'Deploying...'  || isLoading}
            sx={{
              backgroundColor: "#1a1a1a",
              "&:hover": {
                backgroundColor: "#333333",
              },
              "&:disabled": {
                backgroundColor: "#666666",
              },
            }}
          >
            {getDeployButtonText(deploymentStatus) === 'Deploying...' ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                {getDeployButtonText(deploymentStatus)}
              </Box>
            ) : (
              getDeployButtonText(deploymentStatus)
            )}
          </Button>

          {getDeployButtonText(deploymentStatus) === 'Deploying...' && (
            <Button
              variant="contained"
              onClick={handleRefreshDataModels}
              sx={{
                color: "white",
                backgroundColor: "#1a1a1a",
                textTransform: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                boxShadow: "0 4px 6px rgba(26, 26, 26, 0.4)",
                "&:hover": {
                  backgroundColor: "#333",
                },
              }}
            >
              Fetch Status
            </Button>
          )}
        </Box>
      )}
        </Paper>
      </Grid>
      <Grid item {...rightColumnStyles}>
        <Paper elevation={1} className="h-full rounded-lg overflow-hidden">
          <Box sx={{ width: "100%", height: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={dataSideTab} onChange={handleRightTabChange}>
                <Tab label="Data Model" />
                <Tab label="Generated SQL" />
              </Tabs>
             
            </Box>
            <Box sx={{ height: "calc(100% - 48px)" }}>
              {dataSideTab === 0 && (
                <Box sx={{ height: "100%" }}>
                  <FlowContainer
                    type="dataModel"
                    nodes={dataModelNodes[dataModelNodes.length - 1]}
                    setNodes={setDataModelNodes}
                    edges={dataModelEdges[dataModelEdges.length - 1]}
                    setEdges={setDataModelEdges}
                    nodeTypes={customNodes}
                  />
                </Box>
              )}
              {dataSideTab === 1 && (
                <Box className="p-4 h-full">
                  <Box className="flex justify-between items-center mb-4">
                    <Typography variant="h6" className="font-semibold">
                      Generated SQL
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={() => {
                        const blob = new Blob([preAdditionalSql + generatedSQL + postAdditionalSql], {
                          type: "text/plain",
                        });
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = "generated-schema.sql";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                      }}
                      disabled={!generatedSQL}
                      sx={{
                        backgroundColor: "#1a1a1a",
                        "&:hover": {
                          backgroundColor: "#333333",
                        },
                        "&:disabled": {
                          backgroundColor: "#666666",
                        },
                      }}
                    >
                      Download SQL
                    </Button>
                  </Box>
                  <Box
                    component="pre"
                    className="bg-gray-50 p-4 rounded-lg overflow-x-auto"
                    sx={{
                      fontFamily: "monospace",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      height: "calc(100% - 60px)",
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: "8px",
                        height: "8px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0,0,0,.2)",
                        borderRadius: "4px",
                      },
                    }}
                  >
                    {generatedSQL}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Paper>
      </Grid>
    </Grid>
    </>
  );
};

export default DataModelsTab; 